import {addLoader, formatFileSize} from "../../../js/scripts/formFunctions";

document.addEventListener('DOMContentLoaded', () => {

    const isUbOnline = document.querySelector('.ub-online');
    if(!isUbOnline) return;

    /*
      Bestellformular mit GTÜ-Code:
      Hier wird der Ladebalken eingeblendet
    */
    const orderUb = document.querySelector('.ub-order');

    if (orderUb) {
        const form = document.querySelector('.sfg_form');
        const submitButton = document.getElementById('ub_online_kunde_code_bestellung_confirm');

        form.addEventListener('submit', (e) => {
            //Nur wenn Submit-Button geklickt wird
            if (e.submitter !== submitButton) {
                return;
            }

            addLoader(form);

        });
    }

    /*
        UB-Anfrage Formular
        Liste der hochgeladenen Anhänge: Löschen, Hinzufügen und Validierung
    */

    const inquiryForm = document.getElementById('ub-online-kunde-anfrage');
    if(!inquiryForm) return;

    // Relevante DOM-Elemente
    const uploadField = document.querySelector('.uploadField');
    const info = document.querySelector('.hinweis');

    // Validierung der Uploads
    const allowedTypes = ['image/png', 'image/jpeg', 'application/pdf'];
    const allowedSize = 11534336;

    // Zwischenspeicher für Dateien im Upload-Feld
    // notwendig, da <input type="file"> nicht direkt manipulierbar ist
    let uploadFiles = [];

    // Synchronisiert den internen Dateispeicher mit dem echten Input-Feld
    // Workaround über DataTransfer, da file inputs nicht direkt manipulierbar sind
    function syncInputFiles() {
        //Erzeugt leeren Datei-Container
        const dataTransfer = new DataTransfer();
        // Dateien-Liste manuell zusammenbauen
        uploadFiles.forEach(file => {
            dataTransfer.items.add(file);
        });
        // Nötig damit der Browser das neue Dateien-Set akzeptiert
        uploadField.value = '';
        // Das Uploadfeld bekommt meine manuelle Liste
        uploadField.files = dataTransfer.files;
    }

    // Entfernt eine Datei aus der Liste und dem internen Speicher
    const deleteFile = (filename) => {
        // Hinweisbox zurücksetzen
        if (info) info.innerHTML = '';

        uploadFiles = uploadFiles.filter(file => file.name !== filename);
    }

    const fileList = inquiryForm.querySelector('.filelist');

    fileList.addEventListener('click', (e) => {
        e.preventDefault();

        const btn = e.target.closest('.delete');
        if (!btn) return;

        const filename = btn
            .closest('li')
            .querySelector('.filename')
            .innerText;

        // Listenelement entfernen
        btn.closest('li').remove();

        // Daten aktualisieren
        deleteFile(filename);
        syncInputFiles();
    });

    uploadField.addEventListener('change', (e) => {
        //Liste zur Verwaltung der Dateien
        const fileListElement = document.querySelector('.filelist');
        //Dateien die im Uploadfeld ausgewählt wurden
        const newFiles = Array.from(uploadField.files ?? []);

        // Hinweisbox leeren
        info.innerHTML = '';

        newFiles.forEach(newFile => {

            // Array Methode "some" bricht ab, sobald true.
            // wenn nie true dann false.
            // kurz: Prüft, ob Datei bereits existiert
            const exists = uploadFiles.some(
                file => file.name === newFile.name
            );

            // Prüft erlaubte Dateitypen
            const allowedType = allowedTypes.includes(newFile.type);

            if (!exists && allowedType) {
                // Maximal 6 Dateien + Größenlimit prüfen
                if (uploadFiles.length < 6 && newFile.size <= allowedSize) {
                    uploadFiles.push(newFile);
                } else {
                    // Fehler: Datei zu groß
                    if (newFile.size > allowedSize) {
                        info.insertAdjacentHTML('beforeend',
                            `<p class="maxFileSize">Die Datei ${newFile.name} hat mehr als 10 MB
                               und wurde deshalb nicht hinzugefügt.</p>`
                        );
                    } else {
                        // Fehler: zu viele Dateien
                        if (!info.querySelector('.maxAttachments')) {
                            info.insertAdjacentHTML('beforeend',
                                `<p class="maxAttachments">Sie können maximal 6 Anhänge hochladen.</p>`
                            );
                        }
                    }
                }
            }
        });

        // Input-Feld synchronisieren
        syncInputFiles();

        // Liste neu rendern
        fileListElement.innerHTML = uploadFiles
            .map(file => ` <li> <a class="delete icon-trash" href="#">Entfernen</a> <span class="file"><span class="filename">${file.name}</span> (${formatFileSize(file.size)})</span></li>`)
            .join('');
    });

    // Clientseitige Validierung des Anfrageformulars, da bei serverseitiger Validierung
    // die Dateianhänge wieder ausgewählt werden müssen

    inquiryForm.addEventListener('submit', function (e) {
        e.preventDefault();

        const fields = inquiryForm.querySelectorAll('input[required="required"]');
        const errorWrapper = document.createElement('div');
        const errorList = document.createElement('ul');
        const contentBox = document.querySelector('.content-box');
        const heading = contentBox.querySelector('h2');
        const errors = document.querySelector('.errors-ub');

        //Fehler entfernen, wenn vorhanden
        errors?.remove();

        errorWrapper.classList.add('errors-ub');
        errorWrapper.innerHTML = `<p><strong>Bitte überprüfen Sie Ihre Angaben:</strong></p>`;

        fields.forEach((el) => {
            const li = document.createElement('li');

            if (!el.checkValidity()) {
                li.textContent = `${el.dataset.errormsg}`;
                errorList.appendChild(li);
            }

        })
        if (errorList.hasChildNodes()) {
            errorWrapper.insertAdjacentElement('beforeend', errorList);
            heading.insertAdjacentElement('afterend', errorWrapper);

            window.scrollTo({
                top: errorWrapper.offsetTop-50,
                behavior: "smooth"
            });

        } else {

            addLoader(this);
            this.submit();
        }

    });

});